import { render, staticRenderFns } from "./Nutrition.vue?vue&type=template&id=0ff104a7&scoped=true"
import script from "./Nutrition.vue?vue&type=script&lang=js"
export * from "./Nutrition.vue?vue&type=script&lang=js"
import style0 from "./Nutrition.vue?vue&type=style&index=0&id=0ff104a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff104a7",
  null
  
)

export default component.exports